import moment from 'moment';

export const formatFullDateTime = (date?) => moment(date).format('YYYY-MM-DD HH:mm:ss');

export const formatLongDateTime = (date?) => moment(date).format('YYYY-MM-DD HH:mm');

export const formatDate = (date?) => moment(date).format('YYYY-MM-DD');

export const formatTime = (time?) => moment(time).format('HH:mm');
